import { render, staticRenderFns } from "./ContentBlock.vue?vue&type=template&id=7e1d4fa1"
import script from "./ContentBlock.vue?vue&type=script&lang=js"
export * from "./ContentBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports